import classNames from "classnames";
import { realUsersRealResultsBanner } from "@/assets/images";
import { TestimonialsCarousel } from "@/pages/quiz/base/questions/banners/common/beforeAfterSlider";
import { Button, ButtonType } from "@/components/common/button";
import { useIsABTest } from "@/hooks/useIsABTest";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

const RealUsersRealResultsBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const { isABTest_6_Header } = useIsABTest();
  const title = isABTest_6_Header
    ? "Over 50,000 Happy Customers"
    : "Real Users, Real Results.";

  return (
    <>
      <p
        className={classNames(
          "section-title !mb-6",
          isABTest_6_Header &&
            "!font-bold !text-3xl text-center max-w-80 mx-auto"
        )}
      >
        {title}
      </p>
      {isABTest_6_Header ? (
        <TestimonialsCarousel />
      ) : (
        <img
          src={realUsersRealResultsBanner}
          className="max-h-[550px] mx-auto"
          alt={"Real Users, Real Results"}
        />
      )}
      <Button type={ButtonType.NEXT} onClick={() => setQuestionAnswer(true)} />
    </>
  );
};

export { RealUsersRealResultsBanner };
